import { Link } from "react-router-dom";
import { Building2, Droplets, Paintbrush, Grid3x3, Hammer, ArrowUpRight, ArrowRight } from "lucide-react";
import { SectionHeader } from "@/components/SectionHeader";
import { RevealStagger } from "@/components/Reveal";

const cards = [
  { icon: Building2, title: "Ravalement de façade", text: "On redonne à votre façade son état d'origine. Nettoyage, réparation, finition durable.", to: "/ravalement-facade" },
  { icon: Droplets, title: "Nettoyage & hydrofuge", text: "Haute pression, décapage, traitement hydrofuge protecteur pour une façade qui reste propre longtemps.", to: "/nettoyage-hydrofuge" },
  { icon: Paintbrush, title: "Peinture intérieure & extérieure", text: "Peinture soignée, finitions nettes. Intérieur comme extérieur, on prépare avant de peindre.", to: "/peinture" },
  { icon: Grid3x3, title: "Pose de carrelage", text: "Sols, murs, salles de bain. Pose précise, joints réguliers, résultat durable.", to: "/carrelage-maconnerie" },
  { icon: Hammer, title: "Petite maçonnerie", text: "Reprises de maçonnerie liées à vos projets de rénovation. Fissures, réparations, ajustements.", to: "/carrelage-maconnerie" },
];

export const ServicesGrid = () => (
  <section className="py-16 lg:py-28 bg-surface-canvas" data-testid="services-section">
    <div className="max-w-site mx-auto px-5 lg:px-6">
      <SectionHeader
        label="Nos savoir-faire"
        title="Ce qu'on réalise pour vous."
        subtitle="Cinq métiers, une même exigence : que votre maison sorte du chantier plus belle qu'elle n'y est entrée."
      />
      <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map(({ icon: Icon, title, text, to }) => (
          <Link key={title} to={to} className="card-service group" data-testid={`service-card-${to.slice(1)}`}>
            <div className="w-14 h-14 rounded-xl bg-brand-highlight flex items-center justify-center mb-6">
              <Icon size={28} className="text-brand-royal" aria-hidden="true" />
            </div>
            <h3 className="font-heading font-semibold text-[22px] text-brand-deep">{title}</h3>
            <p className="mt-3 text-[15px] text-ink-secondary flex-1">{text}</p>
            <div className="mt-6 self-end">
              <ArrowUpRight size={22} className="card-arrow" aria-hidden="true" />
            </div>
          </Link>
        ))}

        {/* Carte CTA */}
        <div className="rounded-2xl p-8 flex flex-col text-white relative overflow-hidden" style={{ background: "var(--gradient-metal)" }} data-testid="service-card-cta">
          <h3 className="font-heading font-semibold text-[22px]">Un projet particulier ?</h3>
          <p className="mt-3 text-[15px] text-white/85 flex-1">
            Décrivez-nous ce que vous avez en tête. On revient vers vous sous 48h.
          </p>
          <Link to="/devis" className="btn-base btn-white mt-6 self-start !py-3 !px-6 !text-sm" data-testid="service-cta-devis-btn">
            Demander un devis
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </RevealStagger>
    </div>
  </section>
);
